import { useState } from 'react';
import {
  getCookieStringFromSettings,
  getCurrentUrlsMap,
  getDefaultUrlsMap,
  getMfeNames,
} from '@dtna/dvs-core-dcp-client-utils/lib/utils/mfe';

const REMOTE_NAMES = getMfeNames();

interface IMfeToolkitModalProps {
  closeModalCallback?: () => void;
}

function MfeToolkitModal(props: IMfeToolkitModalProps) {
  const { closeModalCallback } = props;
  const [values, setValues] = useState(getCurrentUrlsMap());

  const handleChange = (name: string) => (e: any) => {
    setValues({
      ...values,
      [name]: e.target.value,
    });
  };

  const getExpirationTime = () => {
    const timeToAdd = 1000 * 60 * 60 * 12;
    const date = new Date();
    const expiryTime = date.getTime() + timeToAdd;
    date.setTime(expiryTime);
    const utcTime = date.toUTCString();
    return utcTime;
  };

  const handleReset = () => {
    document.cookie = `MFE_TOOLKIT=; expires='${getExpirationTime()}';path=/;`;
    window.location.reload();
  };

  const handleSubmit = () => {
    const defaultValues = getDefaultUrlsMap();
    const dirtyValues = Object.keys(values).reduce((acc: any, k: string) => {
      if (values[k] !== defaultValues[k]) {
        acc[k] = values[k];
      }
      return acc;
    }, {});
    document.cookie = `MFE_TOOLKIT=${getCookieStringFromSettings(dirtyValues)}; expires='${getExpirationTime()}';path=/;`;
    window.location.reload();
  };

  return (
    <div className="mfe-toolkit-modal">
      <button type="button" className="close" onClick={closeModalCallback}>X</button>
      <h4>MFE TOOLS</h4>
      <p>By changing an MFE URL you can swap that MFE`s URL only for your session:</p>
      <div className="mfe-toolkit-modal-form">
        {REMOTE_NAMES.map((n: string) => (
          <div key={n}>
            <span>{n}</span>
            <input name="mfeUrl" value={values[n]} onChange={handleChange(n)} />
          </div>
        ))}
      </div>
      <button type="button" className="button-submit" onClick={handleSubmit}>Save</button>
      <button type="button" className="button-cancel" onClick={handleReset}>Reset</button>
    </div>
  );
}

export default MfeToolkitModal;
